<div class="dialog__header">
    <h1 class="dialog__title" mat-dialog-title>For the Best Experience</h1>
    <mat-icon mat-button mat-dialog-close class="dialog__icon dialog__close" fontIcon="close" (click)="onClose()"></mat-icon>
  </div>
  <mat-dialog-content>
    <p>This application is optimised for desktop and laptop use. Some features may not display or function fully on mobile devices.</p>
    <p>Please switch to a larger screen for the best experience.</p>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="onClose()">CONTINUE</button>
  </mat-dialog-actions>